export default __webpack_public_path__ + "static/media/feature3.5d5608bf.jpeg";